<vw-toast-popup [isOpen]="isOpen" [title]="shown?.name | Label" (close)="closed.emit()">
  @if (shown; as task) {
    <div class="flex flex-col px-4 pb-8">
      <div class="flex flex-wrap gap-2">
        @if (task.gardenTask?.cropLabel; as crop) {
          <span class="rounded-pill bg-vw-surface-tint px-3 py-1 text-body-s font-medium text-vw-primary-ink">{{ crop }}</span>
        }
        @if (task.gardenTask; as gesture) {
          <span class="rounded-pill bg-vw-surface-sunk px-3 py-1 text-body-s font-medium text-vw-body">
            {{ emojis[gesture.category] }} {{ 'tasks.category.' + gesture.category | translate }}
          </span>
        }
      </div>

      <p class="mt-4 flex items-center gap-2 text-body text-vw-body">
        <svg class="h-5 w-5 shrink-0 text-vw-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
        {{ 'tasks.sheet.window' | translate: period }}
      </p>
      <!-- La lune qualifie le geste quand le jour s'y prête ; elle n'en est jamais la raison. -->
      @if (isLunarDay) {
        <p data-test="sheet-lunar" class="mt-2 flex items-center gap-2 text-body text-vw-body">
          <span class="w-5 shrink-0 text-center" aria-hidden="true">🌙</span>
          {{ 'tasks.sheet.lunar.' + task.gardenTask!.category | translate: { day: ('home.lunar.influence.' + todayInfluence | translate) } }}
        </p>
      }

      @if (task.shortDescription | Label; as detail) {
        <p class="mt-4 whitespace-pre-line text-body text-vw-body">{{ detail }}</p>
      }

      <div class="mt-6 flex flex-col gap-3">
        <vw-button look="primary" label="tasks.sheet.done" customClass="w-full" [iconTemplate]="checkIcon" (onClick)="done.emit()"></vw-button>
        <ng-template #checkIcon><vw-check-icon class="block h-5 w-5 [&>svg]:h-full [&>svg]:w-full" /></ng-template>
        <vw-button look="secondary" label="tasks.sheet.skip" customClass="w-full" (onClick)="skip.emit()"></vw-button>
      </div>
    </div>
  }
</vw-toast-popup>
